import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { useInstanceId } from '../context/instance/instanceContext';
import { createReduxStore } from './store';
export const StoreProvider = ({ children, store: propsStore }) => {
    const instanceId = useInstanceId();
    const [store, setStore] = useState(propsStore || createReduxStore(instanceId));
    useEffect(() => {
        if (propsStore) {
            setStore(propsStore);
        }
    }, [propsStore]);
    return _jsx(Provider, { store: store, children: children });
};
